import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventoAuditoria } from '../../api.service';
import { ServicoAuditoriaAdministrativa } from './servico-auditoria-administrativa';

@Component({
  selector: 'app-grade-eventos-auditoria',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './grade-eventos-auditoria.component.html',
  styleUrls: ['./grade-eventos-auditoria.component.css']
})
export class GradeEventosAuditoriaComponent {
  @Input() eventos: EventoAuditoria[] = [];
  @Input() carregando = false;
  @Input() pagina = 1;
  @Input() tamanho = 50;
  @Input() totalElementos = 0;
  @Input() totalPaginas = 0;

  @Output() paginaChange = new EventEmitter<number>();
  @Output() verCaptura = new EventEmitter<EventoAuditoria>();

  constructor(private readonly servicoAuditoriaAdministrativa: ServicoAuditoriaAdministrativa) {}

  rotuloTipo(tipo: string) {
    return this.servicoAuditoriaAdministrativa.rotuloTipo(tipo);
  }

  podeVerCaptura(evento: EventoAuditoria) {
    return this.servicoAuditoriaAdministrativa.podeVerCaptura(evento);
  }

  resumoQuantidade() {
    if (this.carregando) {
      return 'Carregando eventos...';
    }
    if (this.totalElementos === 0) {
      return 'Nenhum evento encontrado para os filtros selecionados.';
    }
    const inicio = (this.pagina - 1) * this.tamanho + 1;
    const fim = inicio + this.eventos.length - 1;
    return `${inicio} a ${fim} de ${this.totalElementos} eventos.`;
  }
}
